import { List, ListItem, ListItemText } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { useNavigationTabs } from '../../../hooks';
import ChipNew from '../NavigationDesktop/ChipNew';

export default function MobileNavigationActionsList({ onSelect }: { onSelect: (path: string) => void }) {
    const { t } = useTranslation('navigation');
    const { tabs, activeTab } = useNavigationTabs();

    return (
        <List role="list">
            { tabs.map((tab) => (
                <NavigationListItem
                    key={ tab.path }
                    onClick={ () => onSelect(tab.path) }
                    role="listitem"
                    active={ tab.id === activeTab }
                >
                    <ListItemText slotProps={{ 
                        primary: { variant: 'subtitle1' }
                    }}
                    primary={ tab.isNew
                        ? (
                            <span>
                                { t(`navigationItem.${ tab.id }`) }
                                <ChipNew active={ tab.id === activeTab } />
                            </span>
                        )
                        : t(`navigationItem.${ tab.id }`)
                    }
                    />
                </NavigationListItem>
            )) }
        </List>
    );
}

const NavigationListItem = styled(ListItem, {
    shouldForwardProp: (prop) => prop !== 'active'
})<{ active: boolean; }>(({ theme, active }) => (active ? ({
    color: theme.palette.secondary.main
}) : ({ })));
